export default __webpack_public_path__ + "static/media/Instagram.3b03a000.svg";